import { SelectColumnFilter } from 'components/dataTables/FilterTypes/SelectColumnFilter';
import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataMembros = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Membro',
		accessor: 'nomeMembro',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Função',
		accessor: 'funcao',
		type: 'text',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Email',
		accessor: 'email',
		type: 'text',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Área da Empresa',
		accessor: 'areaEmpresa',
		type: 'relation',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Ativo',
		accessor: 'ativo',
		type: 'badge',
		badgeTrueText: 'Ativo',
		Filter: SelectColumnFilter,
		filter: 'equals',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: RowEditAndDelete,
		filter: false,
		module: 'membros',
	},
];
